import React from 'react';
import {Table, TableColumnsType} from "antd";
import {ReportsFilter} from "./index";
import {t} from "i18next";
import useReports from "./useReports";
import {CloseCircleTwoTone} from "@ant-design/icons";

export type AllProductsReport = {
  id: number,
  number: number,
  engineId: number,
  channels: string[],
  products: string[],
  company: string,
  pool: string,
  kpi: string,
  version: string,
  part: string,
  period: string,
}

interface AllProductsProps {
  reportsFilter: ReportsFilter,
  selectedItem: AllProductsReport | undefined,
  setSelectedItem: Function,
}

export default function AllProducts({reportsFilter, selectedItem, setSelectedItem}: AllProductsProps) {
  const columns: TableColumnsType<AllProductsReport> = [
    {
      title: '№',
      dataIndex: 'number',
      key: 'number',
      width: 40,
      render: (value: any, record/*: DataResourceType*/, index: number) => {
        return selectedItem && record.id === selectedItem.id
          ? <CloseCircleTwoTone onClick={() => setSelectedItem(undefined)} twoToneColor={'#1066CB'}/>
          : <a onClick={() => setSelectedItem(record)}>{value}</a>
      },
    },
    {
      title: t('brief.pool'),
      dataIndex: 'pool',
      key: 'pool',
      width: 100,
      sorter: false,
    },
    {
      title: t('brief.company'),
      dataIndex: 'company',
      key: 'company',
      width: 170,
      sorter: false,
    },
    {
      title: t('brief.product'),
      dataIndex: 'products',
      key: 'products',
      width: 170,
      render: (value: any, record/*: DataResourceType*/, index: number) => {
        return value.map((item: string) => <div key={item}>{item}</div>)
      },
      sorter: false,
    },
    {
      title: t('reports.studiedKpi'),
      dataIndex: 'kpi',
      key: 'kpi',
      width: 200,
      sorter: false,
    },
    {
      title: t('list.version'),
      dataIndex: 'version',
      key: 'version',
      width: 60,
      sorter: false,
    },
    {
      title: t('reports.modelingPeriod'),
      dataIndex: 'period',
      key: 'period',
      width: 200,
    },
    {
      title: t('reports.partChannels'),
      dataIndex: 'channels',
      key: 'channels',
      width: 200,
      sorter: false,
      render: (value: any, record/*: DataResourceType*/, index: number) => {
        return <div>{record.channels.join(', ')}</div>
      },
    },
    {
      title: t('reports.part'),
      dataIndex: 'part',
      key: 'part',
      width: 80,
      sorter: false,
      render: (value: any, record/*: DataResourceType*/, index: number) => {
        return <div>{value}%</div>
      },
    },
  ];
  const {reports, isLoading} = useReports(reportsFilter, selectedItem);

  return (
    <>
      <Table
        className={'briefs-table'}
        columns={columns}
        dataSource={reports}
        rowKey={'id'}
        scroll={{x: 800}}
        size={'middle'}
        loading={isLoading}
        onChange={() => {
        }}
        pagination={false}
        bordered
        style={{boxShadow: (selectedItem && selectedItem.id > 0) ? 'rgba(55, 143, 212, 0.2) 0px 3px 8px 0px' : 'none'}}
      />
    </>
  )
}
